
// 관리자페이지의 URL은 사용자가 설정하므로, URL이 고정되어 있지 않다.
// 따라서, 관리자페이지의 ROOT가 되는 URL을 찾아야 한다.
//   (** /{관리자페이지코드}/_setting_ )
//
// ex) /myAdmin/_setting_

export default [
  {
    url: null,
    name: '환경설정',
    icon: 'EditIcon',
    submenu: [
      {
        url: '/general/basic',
        name: '기본환경설정',
        slug: 'notice',
        icon: 'FileIcon'
      },
      {
        url: '/general/register',
        name: '회원가입설정',
        slug: 'faq',
        icon: 'FileIcon'
      },
      {
        url: '/general/menu',
        name: '메뉴설정',
        icon: 'FileIcon'
      }
    ]
  },
  {
    url: null,
    name: '회원관리',
    icon: 'UserIcon',
    submenu: [
      {
        url: '/member/list',
        name: '회원목록',
        slug: 'notice',
        icon: 'FileIcon'
      },
      {
        url: '/member/auth',
        name: '권한관리',
        slug: 'faq',
        icon: 'FileIcon'
      },
      {
        url: '/member/sendmail',
        name: '메일발송',
        slug: 'faq',
        icon: 'FileIcon'
      },
      {
        url: '/member/sendsms',
        name: 'SMS발송',
        slug: 'faq',
        icon: 'FileIcon'
      }
    ]
  },
  {
    url: null,
    name: '게시판관리',
    icon: 'LayoutIcon',
    submenu: [
      {
        url: '/board/list',
        name: '게시판관리',
        slug: 'faq',
        icon: 'FileIcon'
      },
      {
        url: '/board/groups',
        name: '게시판그룹관리',
        slug: 'faq',
        icon: 'FileIcon'
      }
    ]
  },
  {
    url: '/popup/list',
    name: '팝업관리',
    icon: 'CopyIcon'
  },
  {
    url: null,
    name: '전자결재',
    icon: 'CheckCircleIcon',
    submenu: [
      {
        url: '/approval/general',
        name: '사용관리',
        slug: '',
        icon: 'FileIcon'
      },
      {
        url: '/approval/list',
        name: '결재문서관리',
        slug: '',
        icon: 'FileIcon'
      },
      {
        url: '/approval/process',
        name: '결재선관리',
        slug: '',
        icon: 'FileIcon'
      },
      {
        url: '/approval/template',
        name: '양식관리',
        slug: '',
        icon: 'FileIcon'
      },
      {
        url: '/approval/department',
        name: '부서수신함 관리',
        slug: '',
        icon: 'FileIcon'
      },
      {
        url: '/approval/backup',
        name: '결재문서 백업관리',
        slug: '',
        icon: 'FileIcon'
      }
    ]
  },

  {
    url: null,
    name: '통계관리',
    icon: 'FileTextIcon',
    submenu: [
      {
        url: '/info/accessor',
        name: '접속자현황',
        slug: 'notice',
        icon: 'FileIcon'
      },
      {
        url: '/info/accesspath',
        name: '접속경로',
        slug: 'faq',
        icon: 'FileIcon'
      },
      {
        url: '/info/accessos',
        name: 'OS/브라우저',
        slug: 'faq',
        icon: 'FileIcon'
      }
    ]
  }
]
